import { Component } from '@angular/core';

import { CompanyVerificationDialogComponent } from '@core/tellent-company-verification-smart-ui';
import { TellentWebComponent } from '@core/tellent-types';

import { DialogWrapComponent } from '../dialog/dialog-wrap.component';

@Component({
  selector: 'x-company-verification-dialog',
  template: ``,
  imports: [],
})
export class TellentCompanyVerificationDialogWrapComponent extends DialogWrapComponent<CompanyVerificationDialogComponent> {
  public readonly component = CompanyVerificationDialogComponent;
  public readonly config = {
    containerOptions: { fullscreenOnMobile: true },
  };
}

export type TellentCompanyVerificationDialogWebComponent = TellentWebComponent<
  TellentCompanyVerificationDialogWrapComponent,
  'afterClosed' | 'open'
>;
